import { useMutation, gql } from "@apollo/client";
import { CallMeInput, CallMeMutation, CallMeMutationVariables } from "../types/types";

const CALL_ME_MUTATION = gql(`
  mutation CallMe($input: CallMeInput!) {
      callMe(input: $input)
  }
`);

export function useCallMe() {
  const [mutation, info] = useMutation<CallMeMutation, CallMeMutationVariables>(CALL_ME_MUTATION);
  const callMe = async (input: CallMeInput) => {
    const { data } = await mutation({
      variables: { input },
    });
    return data?.callMe ?? false;
  };
  return [callMe, info] as const;
}
